import { refItem } from "@tc/drizzle-v2"
import { eq, and } from "drizzle-orm"
import {
  MessageAttributeValue,
  SQSClient,
  SendMessageCommand,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { pluralizeName } from "../utils/pluralize-package-name"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["PACKAGE_TYPES_QUEUE_URL"]

interface PackageTypeDoc {
  id: string
  code: string
  label: string
  plural_label: string
  description: string
  certificate_types: string[]
}

export const getPackageTypesData = async (
  tx: DbTransaction,
  id: string,
): Promise<PackageTypeDoc | undefined> => {
  const [row] = await tx
    .select({
      id: refItem.id,
      itemCode: refItem.itemCode,
      itemName: refItem.itemName,
    })
    .from(refItem)
    .where(
      and(
        eq(refItem.id, parseInt(id)),
        eq(refItem.listCode, "PKG_ECERT"),
        eq(refItem.active, true),
      ),
    )

  if (!row) {
    console.error(`Package type with id ${id} not found/active`)
    return
  }

  const { plural_label } = pluralizeName(row.itemName || "")

  const doc: PackageTypeDoc = {
    id: row.itemCode,
    code: row.itemCode,
    label: row.itemName || "",
    plural_label,
    description: "",
    certificate_types: ["ORGANICS", "FREE_SALE"],
  }

  searchBuilderLog.debug({ document: doc })

  return doc
}

export const savePackageTypesToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getPackageTypesData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
